'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _PluginState = require('./PluginState');

var _PluginState2 = _interopRequireDefault(_PluginState);

var _PluginContext = require('./PluginContext');

var _PluginContext2 = _interopRequireDefault(_PluginContext);

var _ResolveState = require('./core/ResolveState');

var _ResolveState2 = _interopRequireDefault(_ResolveState);

var _PluginClassLoader = require('./plugin/PluginClassLoader');

var _PluginClassLoader2 = _interopRequireDefault(_PluginClassLoader);

var _Strings = require('./utility/Strings');

var _Strings2 = _interopRequireDefault(_Strings);

var _Constants = require('./Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _log = require('./utility/log');

var _log2 = _interopRequireDefault(_log);

var _fs = require('fs');

var _fs2 = _interopRequireDefault(_fs);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _Framework = require('./core/Framework');

var _Framework2 = _interopRequireDefault(_Framework);

var _PluginConfiguration = require('./PluginConfiguration');

var _PluginConfiguration2 = _interopRequireDefault(_PluginConfiguration);

var _Version = require('./Version');

var _Version2 = _interopRequireDefault(_Version);

var _FrameworkState = require('./core/FrameworkState');

var _FrameworkState2 = _interopRequireDefault(_FrameworkState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 插件类，表示由框架加载的一个插件
 * 
 * @export
 * @class Plugin
 */
var Plugin = function () {
    /**
     * 创建一个插件实例
     * 
     * @ignore
     * @param {Framework} framework 插件框架内部类
     * @param {string} pluginDirectory 插件所在目录
     * @param {PluginConfiguration} pluginConfiguration 插件配置解析结果
     * @memberof Plugin
     */
    function Plugin(framework, pluginDirectory, pluginConfiguration) {
        (0, _classCallCheck3.default)(this, Plugin);

        this.framework = framework;
        this.pluginClassLoader = new _PluginClassLoader2.default(this);
        this.activator = null;

        this._pluginDirectory = pluginDirectory;
        this._pluginConfiguration = pluginConfiguration;
        this._state = _PluginState2.default.INSTALLED;
        this._context;

        this.assertResolved = this.assertResolved.bind(this);
        this.assertUninstalled = this.assertUninstalled.bind(this);

        this.loadClass = this.loadClass.bind(this);
        this.resolveActivator = this.resolveActivator.bind(this);
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.doStart = this.doStart.bind(this);
        this.doStop = this.doStop.bind(this);

        this.uninstall = this.uninstall.bind(this);
    }

    /**
     * 插件id
     * 
     * @readonly
     * @memberof Plugin
     */


    (0, _createClass3.default)(Plugin, [{
        key: 'assertUninstalled',


        /**
         * 诊断是否卸载，如果卸载则抛出异常
         * 
         * @param {string} action 
         * @memberof Plugin
         */
        value: function assertUninstalled(action) {
            if (this._state === _PluginState2.default.UNINSTALLED) {
                throw new Error('Failed to ' + action + ' plugin since the plugin ' + this.id + ' is uninstalled and can not do anything.');
            }
        }

        /**
         * 诊断是否解析，如果没有解析，则抛出异常
         * 
         * @param {string} action 
         * @memberof Plugin
         */

    }, {
        key: 'assertResolved',
        value: function assertResolved(action) {
            if (this._state !== _PluginState2.default.INSTALLED) {
                return;
            }
            if (this.framework.pluginResolver.isResolveSuccess(this.id)) {
                this.state = _PluginState2.default.RESOLVED;
            } else {
                var error = 'Failed to ' + action + ' plugin since the plugin ' + this.id + ' can not be resolved.';
                var pluginMetadata = this.framework.pluginResolver.getPluginMetadata(this.id);
                var dependencyConstraints = pluginMetadata.dependencyConstraints;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(dependencyConstraints), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var dependencyConstraint = _step.value;

                        if (dependencyConstraint.state === _ResolveState2.default.RESOLVEFAILED) {
                            _log2.default.logger.error('The plugin ' + this.id + ' can not be resolved since the dependency can not be resolved for ' + dependencyConstraint.cause + '.');
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                throw new Error(error);
            }
        }

        /**
         * 加载类型
         * 
         * @param {string} classPath 类路径
         * @returns {function}
         * @memberof Plugin
         */

    }, {
        key: 'loadClass',
        value: function loadClass(classPath) {
            this.assertUninstalled('load class from');
            this.assertResolved('load class from');

            return this.pluginClassLoader.loadClass(classPath);
        }

        /**
         * 启动插件
         * 
         * @memberof Plugin
         */

    }, {
        key: 'start',
        value: function start() {
            try {
                this.doStart();
            } catch (error) {
                if (this.state === _PluginState2.default.STARTING) {
                    this._state = _PluginState2.default.RESOLVED;
                }
                _log2.default.logger.error('The plugin ' + this.id + ' is failed to start.', error);
                throw error;
            }
        }

        /**
         * 内部使用，真正进行启动操作
         * 
         * @memberof Plugin
         */

    }, {
        key: 'doStart',
        value: function doStart() {
            if (this._state === _PluginState2.default.ACTIVE) {
                return;
            }

            this.assertUninstalled('start');

            // 0 判断当前启动级别是否大于框架，如果是，不允许启动
            if (this._pluginConfiguration.startLevel > this.framework.startLevel) {
                throw new Error('Failed to start plugin since the plugin ' + this.id + ' startLevel is bigger than framework startLevel.');
            }
            // 1 解析插件
            this.assertResolved('start');
            // 2 更改状态，创建上下文
            _log2.default.logger.info('The plugin ' + this.id + ' is starting.');
            this.state = _PluginState2.default.STARTING;
            this._context = new _PluginContext2.default(this.framework, this);
            // 3 加载激活器
            var activatorClassPath = this.resolveActivator();
            if (activatorClassPath) {
                try {
                    // 4 启动激活器
                    var activatorClass = require(activatorClassPath).default;
                    this.activator = new activatorClass();
                    if (typeof this.activator.start === 'function') {
                        this.activator.start(this._context);
                    }
                } catch (error) {
                    _log2.default.logger.error('Start the activator of plugin ' + this.id + ' failed.', error);
                    throw new Error('Failed to start plugin ' + this.id + ' since load and start activator ' + activatorClassPath + ' failed for ' + error.message + '.');
                }
            } else {
                this.activator = null;
            }

            // 5 启动上下文，加载服务和扩展点
            this._context.start();
            // 6 改变状态
            this.state = _PluginState2.default.ACTIVE;
            _log2.default.logger.info('The plugin ' + this.id + ' is active.');
        }

        /**
         * 解析激活器
         * 
         * @returns {string} 激活器路径，如果没有指定，则返回空
         * @memberof Plugin
         */

    }, {
        key: 'resolveActivator',
        value: function resolveActivator() {
            var activatorClassPath = '';
            if (_Strings2.default.hasText(this.pluginConfiguration.activator)) {
                activatorClassPath = _path2.default.join(this.pluginDirectory, this.pluginConfiguration.activator);
                if (!_fs2.default.existsSync(activatorClassPath)) {
                    throw new Error('Start the plugin ' + this.id + ' failed since the activator ' + activatorClassPath + ' can not be found.');
                }
            } else {
                activatorClassPath = _path2.default.join(this.pluginDirectory, _Constants2.default.defaultActivator);
                if (!_fs2.default.existsSync(activatorClassPath)) {
                    activatorClassPath = '';
                }
            }
            return activatorClassPath;
        }

        /**
         * 停止插件
         * 
         * @memberof Plugin
         */

    }, {
        key: 'stop',
        value: function stop() {
            this.assertUninstalled('stop');

            if (this.framework.state === _FrameworkState2.default.STARTED && !this.pluginConfiguration.stoppable) {
                throw new Error('The plugin ' + this.id + ' can not be stopped since the stoppable is false in plugin.json.');
            }

            try {
                this.doStop();
            } catch (error) {
                _log2.default.logger.error('Exception occurs when stopping the plugin ' + this.id + '.', error);
            } finally {
                this.state = _PluginState2.default.RESOLVED;
                this._context = null;
            }
        }

        /**
         * 内部使用，真正停止插件
         * 
         * @memberof Plugin
         */

    }, {
        key: 'doStop',
        value: function doStop() {
            if (this._state !== _PluginState2.default.ACTIVE) {
                return;
            }

            _log2.default.logger.info('The plugin ' + this.id + ' is stopping.');
            this._state = _PluginState2.default.STOPPING;
            if (this.activator) {
                try {
                    if (typeof this.activator.stop === 'function') {
                        this.activator.stop(this._context);
                    }
                } catch (error) {
                    _log2.default.logger.error('The error occurs while stopping the activator of plugin ' + this.id + ' for ' + error.message + '.', error);
                }
            }

            try {
                this._context.stop();
            } catch (error) {
                _log2.default.logger.error('The error occurs while stopping the context of plugin ' + this.id + ' for ' + error.message + '.', error);
            }

            this._context.dispose();
            _log2.default.logger.info('The plugin ' + this.id + ' is stopped.');
        }

        /**
         * 卸载插件
         * 
         * @memberof Plugin
         */

    }, {
        key: 'uninstall',
        value: function uninstall() {
            // stop()
            this.stop();
            // change state
            this.state = _PluginState2.default.UNINSTALLED;
        }
    }, {
        key: 'id',
        get: function get() {
            return this._pluginConfiguration.id;
        }

        /**
         * 插件名称
         * 
         * @readonly
         * @memberof Plugin
         */

    }, {
        key: 'name',
        get: function get() {
            return this._pluginConfiguration.name;
        }

        /**
         * 插件版本，默认为0.0.0
         * 
         * @type {Version}
         * @readonly
         * @memberof Plugin
         */

    }, {
        key: 'version',
        get: function get() {
            return this._pluginConfiguration.version;
        }

        /**
         * 插件状态
         * 
         * @type PluginState
         * @memberof Plugin
         */

    }, {
        key: 'state',
        get: function get() {
            return this._state;
        }

        /**
         * 插件状态
         * 
         * @type PluginState
         * @memberof Plugin
         */
        ,
        set: function set(state) {
            var previous = this._state;
            this._state = state;
            this.framework.eventManager.firePluginStateChanged(this.id, previous, state);
        }

        /**
         * 插件目录
         * 
         * @readonly
         * @memberof Plugin
         */

    }, {
        key: 'pluginDirectory',
        get: function get() {
            return this._pluginDirectory;
        }

        /**
         * 插件配置解析结果
         * 
         * @type PluginConfiguration
         * @readonly
         * @memberof Plugin
         */

    }, {
        key: 'pluginConfiguration',
        get: function get() {
            return this._pluginConfiguration;
        }

        /**
         * 插件上下文
         * 
         * @type PluginContext
         * @readonly
         * @memberof Plugin
         */

    }, {
        key: 'context',
        get: function get() {
            return this._context;
        }
    }]);
    return Plugin;
}();

exports.default = Plugin;
//# sourceMappingURL=Plugin.js.map